import React from 'react'
import { Link } from "react-router-dom"
import oujablog from "../../assets/layout/oujablog.png"
import oujareview from "../../assets/layout/oujareview.png"


const Footer = () => {
    return (
        <footer className="custom-footer">
            <div className="container">
                <div className="row m-t-10">
                    <div className="col-md-2" />
                    <div className="col-md-9">
                        <div className="row">
                            <div className="col-md-3 flex-center">
                                <Link to="/team" className="btn btn-pad btn-ouja btn-raised m-b-20">
                                    Our Team
                                </Link>
                            </div>
                            <div className="col-md-3 flex-center">
                                <Link to="/careers" className="btn btn-pad btn-ouja btn-raised m-b-20">
                                    Careers
                                </Link>
                            </div>
                            <div className="col-md-3 flex-center">
                                <Link to="/become-a-rider" className="btn btn-pad btn-ouja btn-raised m-b-20">
                                    Become Rider
                                </Link>
                            </div>
                            <div className="col-md-3 flex-center">
                                <Link to="/become-a-partner" className="btn btn-pad btn-ouja btn-raised m-b-20">
                                    Become Partner
                                </Link>
                            </div>
                        </div>   
                    </div>
                    <div className="col-md-3" /> 
                </div>
                <ul className="footer-links list-unstyled flex-center m-t-30">
                    <li>
                        <Link to="/faqs">FAQ's</Link>
                    </li>
                    <li>
                        <Link to="/contact-us">Contact Us</Link>
                    </li>
                    <li>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                        <Link to="/terms-and-conditions">Terms & Conditions</Link>
                    </li>
                </ul>
                <ul className="footer-links list-unstyled flex-center">
                    <li>
                        <a href="https://www.facebook.com/Ouja-557268384728637/"><i className="fab fa-facebook-f"></i></a>
                    </li>
                    <li>
                        <a href="https://twitter.com/OujaIndia"><i className="fab fa-twitter"></i></a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/oujaindia/"><i className="fab fa-instagram"></i></a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/channel/UCaHd88KEbMxSUI6U1qYPdzw/"><i className="fab fa-youtube"></i></a>
                    </li>
                    <li>
                    <a href="https://blog.ouja.in/"><img class="ouja-blog" src={oujablog}/></a>
                    
  
                    </li>
                    <li>
                    <a href="https://reviews.ouja.in/"><img class="ouja-review" src={oujareview}/></a>
                    
                    </li>
                    
                </ul>
                <div className="flex-center">
                    Powered by <Link className="billiontags" to="/"> Ouja</Link>
                </div>
            </div>
        </footer>
    )
}

export default Footer
